import type { QuotaSnapshot, ResearchRunDetail, ResearchRunListResponse } from "../types";

export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

export class QuotaExceededError extends Error {
  quota: QuotaSnapshot;

  constructor(quota: QuotaSnapshot, message = "Research quota exceeded") {
    super(message);
    this.name = "QuotaExceededError";
    this.quota = quota;
  }
}

export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const response = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: "include",
  });

  if (response.status === 429) {
    const data = await response.json().catch(() => null);
    if (data?.quota) {
      throw new QuotaExceededError(data.quota as QuotaSnapshot, data.error);
    }
  }

  return response;
}

export async function fetchRuns(cursor?: string | null): Promise<ResearchRunListResponse> {
  const search = cursor ? `?cursor=${encodeURIComponent(cursor)}` : "";
  const response = await apiFetch(`/research/runs${search}`);
  if (!response.ok) {
    throw new Error(`Erro HTTP! status: ${response.status}`);
  }
  return response.json();
}

export async function fetchRun(id: string): Promise<ResearchRunDetail> {
  const response = await apiFetch(`/research/runs/${encodeURIComponent(id)}`);
  if (!response.ok) {
    throw new Error(`Erro HTTP! status: ${response.status}`);
  }
  return response.json();
}

export async function deleteRun(id: string): Promise<void> {
  const response = await apiFetch(`/research/runs/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (!response.ok) {
    throw new Error(`Erro HTTP! status: ${response.status}`);
  }
}

export async function fetchQuota(): Promise<QuotaSnapshot> {
  const response = await apiFetch("/research/quota");
  if (!response.ok) {
    throw new Error(`Erro HTTP! status: ${response.status}`);
  }
  const data = await response.json();
  return data.quota as QuotaSnapshot;
}
